import ReviewApproval from "features/approve-review";
import HeroMedia from "features/hero-media";
import BlogsNews from "features/blogs-news";
import Categories from "features/categories";
import FooterSeo from "features/footer-seo";
import MainDashboard from "features/main-dashboard";
import Orders from "features/orders";
import PartnerApproval from "features/partner-approval";
import Product from "features/product";
import CategorySlider from "features/category-slider/components/CategorySlider";
import MovingText from "features/moving-text/components/MovingText";
import OurFeatures from "features/our-features/components/OurFeatures";
import ProductRecommend from "features/product-recommend/components/ProductRecommend";
import FooterSettings from "features/footer-settings/components/FooterSettings";
import FAQ from "features/faq/components/FAQ";
import PopupSettings from "features/popup-settings";
import PrivacyPolicy from "features/privacy-policy/components/PrivacyPolicy";
import DeliveryPolicy from "features/delivery-policy/components/DeliveryPolicy";
import WarrantyPolicy from "features/warranty-policy/components/WarrantyPolicy";
import TermsConditions from "features/terms-conditions/components/TermsConditions";
import ReturnExchange from "features/return-exchange/components/ReturnExchange";
import SocialMedia from "features/social-media";
import OnlineShop from "features/online-shop/components/OnlineShop";
import CustomProductGrid from "features/custom-product-grid";
import ProductSections from "features/product-sections";
import AllUsers from "features/all-users";
import ManualOrder from "features/manual-order";
import { MdLocalOffer } from "react-icons/md";
import Coupons from "features/coupons";
import AboutUsEditor from "features/about-us";

import {
  MdHome,
  MdNewspaper,
  MdOutlineCategory,
  MdOutlineList,
  MdOutlinePerson,
  MdOutlineShoppingCart,
  MdOutlineStars,
  MdViewCarousel,
  MdTextFields,
  MdFeaturedPlayList,
  MdRecommend,
  MdDashboard,
  MdSettings,
  MdImage,
  MdInfo,
  MdHelp,
  MdPrivacyTip,
  MdLocalShipping,
  MdSecurity,
  MdGavel,
  MdSwapHoriz,
  MdStore,
  MdShare,
  MdGridOn,
  MdAddShoppingCart,
} from "react-icons/md";
import { RiSeoLine } from "react-icons/ri";
import { IoMdImage } from "react-icons/io";

const routes = [
  {
    name: "Main Dashboard",
    layout: "/admin",
    path: "dashboard",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
  },
  {
    name: "All Users",
    layout: "/admin",
    path: "all-users",
    icon: <MdOutlinePerson className="h-6 w-6" />,
    component: <AllUsers />,
  },
  {
    name: "Product",
    layout: "/admin",
    path: "product",
    icon: <MdOutlineShoppingCart className="h-6 w-6" />,
    component: <Product />,
  },
  {
    name: "Categories",
    layout: "/admin",
    path: "category",
    icon: <MdOutlineCategory className="h-6 w-6" />,
    component: <Categories />,
  },
  {
    name: "Custom Product Grid",
    layout: "/admin",
    path: "custom-product-grid",
    icon: <MdGridOn className="h-6 w-6" />,
    component: <CustomProductGrid />,
  },
  {
    name: "Home 3 Sections",
    layout: "/admin",
    path: "product-sections",
    icon: <MdImage className="h-6 w-6" />,
    component: <ProductSections />,
  },
  {
    name: "Partner Approval",
    layout: "/admin",
    path: "partner-approval",
    icon: <MdOutlinePerson className="h-6 w-6" />,
    component: <PartnerApproval />,
  },
  {
    name: "Orders",
    layout: "/admin",
    path: "orders",
    icon: <MdOutlineList className="h-6 w-6" />,
    component: <Orders />,
  },
  {
    name: "Manual Order",
    layout: "/admin",
    path: "manual-order",
    icon: <MdAddShoppingCart className="h-6 w-6" />,
    component: <ManualOrder />,
  },
  {
    name: "Approve Review",
    layout: "/admin",
    path: "approve-review",
    icon: <MdOutlineStars className="h-6 w-6" />,
    component: <ReviewApproval />,
  },
  {
    name: "Hero Media",
    layout: "/admin",
    path: "hero-media",
    icon: <IoMdImage className="h-6 w-6" />,
    component: <HeroMedia />,
  },
  {
    name: "Category Slider",
    layout: "/admin",
    path: "category-slider",
    icon: <MdViewCarousel className="h-6 w-6" />,
    component: <CategorySlider />,
  },
  {
    name: "Moving Text",
    layout: "/admin",
    path: "moving-text",
    icon: <MdTextFields className="h-6 w-6" />,
    component: <MovingText />,
  },
  {
    name: "Our Features",
    layout: "/admin",
    path: "our-features",
    icon: <MdFeaturedPlayList className="h-6 w-6" />,
    component: <OurFeatures />,
  },
  {
    name: "Product Recommend",
    layout: "/admin",
    path: "product-recommend",
    icon: <MdRecommend className="h-6 w-6" />,
    component: <ProductRecommend />,
  },
  {
    name: "Blogs & News",
    layout: "/admin",
    path: "blog-news",
    icon: <MdNewspaper className="h-6 w-6" />,
    component: <BlogsNews />,
  },
  {
    name: "Social Media",
    layout: "/admin",
    path: "social-media",
    icon: <MdShare className="h-6 w-6" />,
    component: <SocialMedia />,
  },
  {
    name: "Footer SEO",
    layout: "/admin",
    path: "footer-seo",
    icon: <RiSeoLine className="h-6 w-6" />,
    component: <FooterSeo />,
  },
  {
    name: "Footer Settings",
    layout: "/admin",
    path: "footer-settings",
    icon: <MdInfo className="h-6 w-6" />,
    component: <FooterSettings />,
  },
  {
    name: "FAQ",
    layout: "/admin",
    path: "faq",
    icon: <MdHelp className="h-6 w-6" />,
    component: <FAQ />,
  },
  {
    name: "Privacy Policy",
    layout: "/admin",
    path: "privacy-policy",
    icon: <MdPrivacyTip className="h-6 w-6" />,
    component: <PrivacyPolicy />,
  },
  {
    name: "Delivery Policy",
    layout: "/admin",
    path: "delivery-policy",
    icon: <MdLocalShipping className="h-6 w-6" />,
    component: <DeliveryPolicy />,
  },
  {
    name: "Warranty Policy",
    layout: "/admin",
    path: "warranty-policy",
    icon: <MdSecurity className="h-6 w-6" />,
    component: <WarrantyPolicy />,
  },
  {
    name: "Terms & Conditions",
    layout: "/admin",
    path: "terms-conditions",
    icon: <MdGavel className="h-6 w-6" />,
    component: <TermsConditions />,
  },
  {
    name: "Return & Exchange",
    layout: "/admin",
    path: "return-exchange",
    icon: <MdSwapHoriz className="h-6 w-6" />,
    component: <ReturnExchange />,
  },
  {
    name: "Popup Settings",
    layout: "/admin",
    path: "popup-settings",
    icon: <MdSettings className="h-6 w-6" />,
    component: <PopupSettings />,
  },
  {
    name: "Online Shop",
    layout: "/admin",
    path: "online-shop",
    icon: <MdStore className="h-6 w-6" />,
    component: <OnlineShop />,
  },
  {
    name: "Manage Coupons",
    layout: "/admin",
    path: "manage-coupons",
    icon: <MdLocalOffer className="h-6 w-6" />,
    component: <Coupons />,
  },
  {
    name: "About Us",
    layout: "/admin",
    path: "about-us",
    icon: <MdInfo className="h-6 w-6" />,
    component: <AboutUsEditor />,
  },
];

export default routes;
